import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { apiWrapper } from "apis/CommonApi";
import * as accountApi from "../apis/AccountApi";
import {
  GeneralUserTypeChoice,
  getGeneralUserTypeName,
  getUserAuthorityName,
  UserAuthorityChoice,
} from "utils/common";

export default function JoinPage() {
  return (
    <div id="wrap">
      <Main />
    </div>
  );
}

function Main() {
  return (
    <main id="main" className="main">
      <HeadSection />
      <JoinSection />
    </main>
  );
}

function HeadSection() {
  return (
    <section className="headSection">
      <div className="container cont-960">
        <div className="wrap_head">
          <div className="wrap_title">
            <Link className="logo bold" to="/">
              LOGO
            </Link>
            <span className="bar"></span>
            <p className="title">스마트 AIoT 화재 모니터링 시스템</p>
          </div>
        </div>
      </div>
    </section>
  );
}

function JoinSection() {
  const navigate = useNavigate();
  const [isIdAvailable, setIdAvailable] = useState(false); // ID 사용 가능 여부
  const [isPasswordMatch, setPasswordMatch] = useState(false); // 비밀번호 일치 여부
  const [isCompletedPassword, setCompletedPassword] = useState(false); // 비밀번호 입력 완료 여부
  const [isCompletedPasswordConfirm, setCompletedPasswordConfirm] =
    useState(false); // 비밀번호 확인 입력 완료 여부
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    setFormDataProperty("userAuthority", UserAuthorityChoice.BUSINESS);
    setFormDataProperty("userId", "");
    setFormDataProperty("password", "");
    setFormDataProperty("passwordConfirm", "");
    setFormDataProperty("userName", "");
    setFormDataProperty("title", "");
    setFormDataProperty("phoneNumber", "");
    setFormDataProperty("email", "");
    setFormDataProperty("businessNumber", "");
    setFormDataProperty("userType", GeneralUserTypeChoice.FIRE_SAFETY_ADMIN);
    setFormDataProperty("profileImageSrc", "");
    setFormDataProperty("profileImageFile", null);
  }, []);

  const setFormDataProperty = (name, value) => {
    setFormData((currentFormData) => {
      const nextFormData = {
        ...currentFormData,
        [name]: value,
      };
      //console.log(nextFormData);
      return nextFormData;
    });
  };

  const onChange = (e) => {
    if (e.target.type === 'file') {
      const files = e.target.files;
      if (files.length > 0) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const profileImage = e.target.result;
          setFormDataProperty("profileImageSrc", profileImage);
          setFormDataProperty("profileImageFile", files[0]);
        };
        reader.readAsDataURL(files[0]);
      }
    } else {
      let name = e.target.name;
      let value = e.target.value;
      setFormDataProperty(name, value);
    }
  };

  const handleCheckDuplicate = () => {
    if (formData.userId === "") {
      alert(`아이디를 입력해주세요.`);
    } else {
      apiWrapper(async () => {
        let result = await accountApi.checkDuplicateId(formData.userId);

        const { status, data } = result;
        if (status === true) {
          setIdAvailable(true);
        } else {
          setIdAvailable(false);
          alert(`${data}`);
        }
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else if (checkValid() === false) {
      e.stopPropagation();
    } else {
      apiWrapper(async () => {
        const requestBody = new FormData();
        requestBody.append("profileImage", formData.profileImageFile);
        const userData = {
          userId: formData.userId,
          password: formData.password,
          userName: formData.userName,
          phoneNumber: formData.phoneNumber.trim().replace(/-/g, ""),
          email: formData.email,
        };
        requestBody.append("userData", JSON.stringify(userData));

        if (formData.userAuthority === UserAuthorityChoice.BUSINESS) {
          //사업자
          const businessData = {
            businessNumber: formData.businessNumber,
          };
          requestBody.append("businessData", JSON.stringify(businessData));
        } else if (formData.userAuthority === UserAuthorityChoice.GENERAL) {
          //사용자
          const generalData = {
            userType: formData.userType,
            title: formData.title,
          };
          requestBody.append("generalData", JSON.stringify(generalData));
        }

        const { status, data } = await accountApi.join(requestBody);
        alert(`${data}`);

        if (status === true) {
          navigate("/");
        }
      });
    }
  };

  const checkValid = () => {
    if (isIdAvailable === false) {
      alert("아이디를 확인해주세요.");
      return false;
    } else if (isPasswordMatch === false) {
      alert("패스워드를 확인해주세요.");
      return false;
    } else if (formData.profileImageFile === null) {
      alert(`프로필 이미지를 선택해주세요.`);
      return false;
    }

    return true;
  };

  const handleCheckPasswordMatch = () => {
    if (formData.password === formData.passwordConfirm) {
      setPasswordMatch(true);
    } else {
      setPasswordMatch(false);
    }
  };

  return (
    <section className="joinSection">
      <div className="container cont-960">
        <form onSubmit={handleSubmit}>
          <div className="whiteBoard wrap_join">
            <button type="button" className="btn_prev" onClick={() => navigate(-1)}>
              <i className="x-icon icon_prev"></i>
            </button>
            <p className="title_whiteBoard">회원가입</p>
            {formData && (
              <div className="wrap_input">
                <div className="item_input">
                  <p className="title_item">구분</p>
                  <div className="wrap_inner wrap_radio_inner">
                    {/* "전체" 상태는 제외하고 전시 */}
                    {Object.values(UserAuthorityChoice).map((item, index) =>
                      index === 0 ? null : (
                        <label
                          className={`radio-item ${formData.userAuthority === item ? "active" : ""
                            }`}
                        >
                          <input
                            type="radio"
                            class="form-radio"
                            name="userAuthority"
                            value={item}
                            checked={formData.userAuthority === item}
                            onChange={onChange}
                          />
                          <span className="radio-icon">
                            <i className="xi-check"></i>
                          </span>
                          <p className="radio-title">
                            {getUserAuthorityName(item)}
                          </p>
                        </label>
                      )
                    )}
                  </div>
                </div>

                {/* ID 입력 */}
                <div className="item_input">
                  <p className="title_item">아이디</p>
                  <div className="wrap_inner type2">
                    <div className="wrap_enter">
                      <input
                        type="text"
                        className="defaultInput"
                        name="userId"
                        value={formData.userId}
                        onChange={onChange}
                        required="required"
                      />
                      <button
                        type="button"
                        className="btn_grey"
                        onClick={handleCheckDuplicate}
                      >
                        중복확인
                      </button>
                    </div>
                    {isIdAvailable && (
                      <div className="wrap_guide blue">
                        <i className="x-icon txt_guide"></i>
                        <p className="txt_guide">사용 가능한 ID입니다.</p>
                      </div>
                    )}
                  </div>
                </div>

                {/* 패스워드 입력 */}
                <div className="item_input">
                  <p className="title_item">패스워드</p>
                  <input
                    type="password"
                    className="defaultInput"
                    name="password"
                    value={formData.password}
                    onChange={onChange}
                    onBlur={() => {
                      formData.password
                        ? setCompletedPassword(true)
                        : setCompletedPassword(false);
                      handleCheckPasswordMatch();
                    }}
                    required="required"
                  />
                </div>

                {/* 패스워드 확인 */}
                <div className="item_input">
                  <p className="title_item">패스워드 확인</p>
                  <div className="wrap_inner type2">
                    <div className="wrap_enter">
                      <input
                        type="password"
                        className="defaultInput"
                        name="passwordConfirm"
                        value={formData.passwordConfirm}
                        onChange={onChange}
                        onBlur={() => {
                          formData.passwordConfirm
                            ? setCompletedPasswordConfirm(true)
                            : setCompletedPasswordConfirm(false);
                          handleCheckPasswordMatch();
                        }}
                        required="required"
                      />
                    </div>
                    {isCompletedPassword &&
                      isCompletedPasswordConfirm &&
                      isPasswordMatch === false && (
                        <div className="wrap_guide red">
                          <i className="x-icon txt_guide"></i>
                          <p className="txt_guide">
                            패스워드가 동일하지 않습니다.
                          </p>
                        </div>
                      )}
                  </div>
                </div>

                {/* 사용자 명 */}
                <div className="item_input">
                  <p className="title_item">사용자 명</p>
                  <input
                    type="text"
                    className="defaultInput"
                    name="userName"
                    value={formData.userName}
                    onChange={onChange}
                    required="required"
                  />
                </div>

                {formData.userAuthority === UserAuthorityChoice.GENERAL && (
                  <div className="item_input">
                    <p className="title_item">직함/직책</p>
                    <input
                      type="text"
                      className="defaultInput"
                      name="title"
                      value={formData.title}
                      onChange={onChange}
                      required="required"
                    />
                  </div>
                )}

                {/* 연락처 */}
                <div className="item_input">
                  <p className="title_item">연락처</p>
                  <input
                    type="text"
                    className="defaultInput"
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={onChange}
                    required="required"
                  />
                </div>

                {/* 이메일 입력 */}
                <div className="item_input">
                  <p className="title_item">이메일</p>
                  <div className="wrap_inner type2">
                    <div className="wrap_enter">
                      <input
                        type="text"
                        className="defaultInput"
                        name="email"
                        value={formData.email}
                        onChange={onChange}
                        required="required"
                      />
                    </div>
                  </div>
                </div>

                {formData.userAuthority === UserAuthorityChoice.BUSINESS && (
                  <>
                    {/* 사업자 번호 */}
                    <div className="item_input">
                      <p className="title_item">사업자 번호</p>
                      <input
                        type="number"
                        className="defaultInput"
                        name="businessNumber"
                        value={formData.businessNumber}
                        onChange={onChange}
                        required="required"
                      />
                    </div>
                  </>
                )}

                {formData.userAuthority === UserAuthorityChoice.GENERAL && (
                  <>
                    {/* 사용자 구분 */}
                    <div className="item_input">
                      <p className="title_item">사용자 구분</p>
                      <div className="wrap_inner type2">
                        <div className="wrap_radio">
                          {Object.values(GeneralUserTypeChoice).map(
                            (item, index) => (
                              <label className="radio-item">
                                <input
                                  type="radio"
                                  class="form-radio"
                                  name="userType"
                                  key={index}
                                  value={item}
                                  checked={formData.userType === item}
                                  onChange={onChange}
                                />
                                <span className="radio-icon">
                                  <i className="xi-check"></i>
                                </span>
                                <p className="radio-title">
                                  {getGeneralUserTypeName(item)}
                                </p>
                              </label>
                            )
                          )}
                        </div>
                        <p className="txt_guide type2">
                          <span>※</span>
                          소방안전관리자 및 보조안전관리자는 소방대상물{" "}
                          <br className="mb" /> 신규 등록/수정 및 화재수신기
                          원격제어가 가능합니다.
                        </p>
                      </div>
                    </div>
                  </>
                )}

                <div className="item_input">
                  <p className="title_item">프로필 이미지</p>
                  <div class="file-input">
                    <label for="file-upload" class="file-upload-btn">+</label>
                    <input type="file" accept=".png, .jpg, .jpeg" id="file-upload" class="file-upload-input" name="profileImage" onChange={onChange} />
                    {formData.profileImageFile && (
                      <div class="wrap_profile">
                        <div class="icon-item">
                          <img src={formData.profileImageSrc} alt="" />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            <button type="submit" className="btn_orange btn_signup">
              회원가입
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
